import { createTheme, responsiveFontSizes } from '@mui/material'

// For custom theme in MUI
const theme = createTheme({

})

export default responsiveFontSizes(theme)